<template>
  <div class="white maxContainer wrap">
    <div class="maxContainer">
      <!-- Mobile App Bar -->
      <v-app-bar
        class="grey lighten-3 elevation-0 d-md-none"
        fixed
        style="zIndex: 500; "
      >
        <v-layout class=" mb-0 mt-0 pt-0 pb-1" row align-center>
          <!-- User Name -->
          <v-layout ml-2 align-content-start justify-start>
            <v-toolbar-title
              v-if="user !== null && user !== undefined"
              class="font-weight-medium grey--text text--darken-3 white--text"
              >{{ user.name }}</v-toolbar-title
            >
            <v-toolbar-title
              v-else
              class="grey--text text--darken-3 font-weight-medium  ml-2"
              >Guest</v-toolbar-title
            >
          </v-layout>

          <v-spacer></v-spacer>

          <!-- Login Button -->
          <v-layout row justify-space-around mt-1 mr-2 style="width:50px">
            <v-layout
              v-if="user === null || user === undefined"
              @click="showLoginSignUpScreen"
              column
              align-end
              justify-end
              mr-1
            >
              <v-icon color="green" class="mt-2 mr-1">mdi-power</v-icon>
              <span class="caption green--text mb-2">Login</span>
            </v-layout>
            <!-- Profile Button -->
            <v-layout
              v-if="user !== null && user !== undefined"
              @click="showAccountScreen"
              column
              align-end
              justify-end
              ml-5
            >
              <!--
                <v-btn  fab small   color="grey  darken-3"> <v-icon color="white" >mdi-account-circle</v-icon></v-btn>
              -->
              <v-icon color="blue darken-3" class="mt-2 mr-1"
                >mdi-account-circle</v-icon
              >
              <span class="caption blue--text text--darken-3 mb-2  "
                >Profile</span
              >
            </v-layout>

            <!-- Logout Button -->
            <v-layout
              v-if="user !== null && user !== undefined"
              @click="logout"
              column
              align-end
              justify-end
              mr-1
            >
              <v-icon color="red" class="mt-2 mr-2">mdi-power</v-icon>
              <span class="caption red--text mb-2">Logout</span>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-app-bar>

      <!-- Mobile Layout -->
      <v-container class="d-md-none">
        <!-- Saved Schools and My Grades Row -->
        <v-layout row wrap>
          <!-- Saved Schools -->
          <v-flex xs6>
            <v-card id="card" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/savedschools"
                    color="white"
                    icon
                    fab
                    class="mb-0 pb-0"
                  >
                    <v-icon color="green lighten-1" large>mdi-bookmark</v-icon>
                  </v-btn>

                  <span class="subheading blue-grey--text text--lighten-1"
                    >Saved Schools</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <!-- My Grades -->
          <v-flex xs6>
            <v-card class="" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/mygrades"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="orange"
                      >mdi-format-annotation-plus</v-icon
                    >
                  </v-btn>
                  <span class="subheading blue-grey--text text--lighten-1"
                    >My Grades</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
        <v-divider class="mx-4"></v-divider>

        <!-- Pa Shadowing and Healthcare Hours Row -->
        <v-layout row wrap mt-2>
          <!-- PA Shadowing -->
          <v-flex xs6>
            <v-card id="card" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/pashadowing"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="cyan">mdi-account-multiple</v-icon>
                  </v-btn>

                  <span class="subheading blue-grey--text text--lighten-1"
                    >PA Shadowing</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <!-- Healthcare Hours -->
          <v-flex xs6>
            <v-card class="" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/healthcarehours"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="red">mdi-hospital-box</v-icon>
                  </v-btn>

                  <span class="subheading blue-grey--text text--lighten-1"
                    >Healthcare Hours</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>

        <v-divider class="mx-4"></v-divider>

        <!-- Evaluations and Exams Row -->
        <v-layout row wrap mt-2>
          <!-- Evaluations -->
          <v-flex xs6>
            <v-card id="card" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/evaluations"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="purple lighten-2"
                      >mdi-account-voice</v-icon
                    >
                  </v-btn>

                  <span class="subheading blue-grey--text text--lighten-1"
                    >Evaluations</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Exams -->
          <v-flex xs6>
            <v-card class="" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/dashboard/exams"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="indigo lighten-1"
                      >mdi-file-document</v-icon
                    ></v-btn
                  >
                  <span class="subheading blue-grey--text text--lighten-1"
                    >Exams</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
        <v-divider class="mx-4"></v-divider>

        <!-- Resources and Empty Row -->
        <v-layout row wrap mt-2>
          <!-- Services -->
          <v-flex xs6>
            <v-card id="card" flat>
              <v-container fill-height fluid>
                <v-layout column align-center justify-center>
                  <v-btn
                    to="/services"
                    color="white"
                    fab
                    icon
                    class="mb-0 pb-0"
                  >
                    <v-icon large color="teal lighten-2">mdi-face-agent</v-icon>
                  </v-btn>

                  <span class="subheading blue-grey--text text--lighten-1"
                    >Services</span
                  >
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <!-- Resources -->
          <v-flex xs6>
            <v-card id="" flat>
              <v-container fill-height fluid>
                <!--
                  <v-layout column align-center justify-center>
                    <v-btn
                      to="/dashboard/resources"
                      color="white"
                      fab
                      icon
                      class="mb-0 pb-0"
                    >
                      <v-icon large color="deep-orange  ">mdi-hubspot</v-icon>
                    </v-btn>

                    <span class="subheading blue-grey--text text--lighten-1"
                      >Resources</span
                    >
                  </v-layout>
                -->
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- Desktop App Bar -->

      <div class="hidden-sm-and-down wrap">
        <template>
          <v-tabs
            vertical
            align-with-title
            background-color="transparent"
            hide-slider
            v-model="tab"
            class="mt-5"
          >
            <div class="pr-4 mr-4">
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="green lighten-1"
                  >mdi-bookmark</v-icon
                >
                Saved PA Schools
              </v-tab>
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="orange"
                  >mdi-format-annotation-plus</v-icon
                >
                Grades
              </v-tab>
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="cyan">mdi-account-multiple</v-icon>
                PA Shadowing
              </v-tab>
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="red">mdi-hospital-box</v-icon>
                Healthcare Hours
              </v-tab>
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="purple lighten-2"
                  >mdi-account-voice</v-icon
                >
                Evaluations
              </v-tab>
              <v-tab
                class="ml-0 justify-start col-sm-12 "
                active-class="activeLink darken-3 white--text"
              >
                <v-icon class="mr-1" color="indigo lighten-1"
                  >mdi-file-document</v-icon
                >
                Exams
              </v-tab>
              <!--
                <v-tab
                  class="ml-0 justify-start col-sm-12 "
                  active-class="activeLink darken-3 white--text"
                >
                  <v-icon class="mr-1" color="deep-orange ">mdi-hubspot</v-icon>
                  Resources
                </v-tab>
              -->
            </div>
            <!-- Desktop Tabs -->
            <v-tabs-items vertical class="hidden-sm-and-down " v-model="tab">
              <!-- Saved Schools Tab -->
              <v-tab-item> <SavedSchools /> </v-tab-item>

              <!-- My Grades Tab -->
              <v-tab-item> <Grades /> </v-tab-item>

              <!-- PA Shadowing Tab -->
              <v-tab-item> <PaShadowingHours /> </v-tab-item>

              <!-- Healthcare Hours -->
              <v-tab-item> <HealthcareHours /> </v-tab-item>

              <!-- Evaluations -->
              <v-tab-item> <Evaluations /> </v-tab-item>

              <!-- Exams -->
              <v-tab-item> <Exams /> </v-tab-item>

              <!-- Resources -->
              <v-tab-item> <Resources /> </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase";
import overallCheckMixin from "@/mixins/requirementchecks/overallmixin";

// import Prelogin from '@/components/Dashboard/Prelogin/Prelogin'
export default {
  mixins: [overallCheckMixin],
  components: {},
  data() {
    return {
      tab: null,
      alert: true,
      status: 60,
      value: 100
    };
  },
  methods: {
    moreInfo(savedSchoolId) {
      this.$router.push(
        "/dashboard/savedschools/savedschoolinfo/" + savedSchoolId
      );
    },
    showLoginSignUpScreen() {
      this.$router.push("/LoginSignupPage");
    },
    close() {
      this.$router.go("-1");
    },
    showAccountScreen() {
      this.$router.push("/myaccount");
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(function() {});
      var user = null;
      this.$store.dispatch("logout", user);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    savedSchools() {
      return this.$store.getters.savedSchools;
    },
    userEvaluations() {
      return this.$store.getters.userEvaluations;
    },
    paShadowingHours() {
      return this.$store.getters.paShadowingHours;
    },
    totalPaShadowingHours() {
      return this.$store.getters.totalPaShadowingHours;
    },
    directPaidPatientHours() {
      return this.$store.getters.directPaidPatientInfo;
    },
    totalDirectPaidPatientHours() {
      return this.$store.getters.totalDirectPaidHours;
    },
    directPatientHours() {
      return this.$store.getters.directPatientInfo;
    },
    totalDirectHours() {
      return this.$store.getters.totalDirectHours;
    },
    indirectPatientHours() {
      return this.$store.getters.indirectPatientInfo;
    },
    totalIndirectHours() {
      return this.$store.getters.totalIndirectHours;
    },
    volunteerPatientHours() {
      return this.$store.getters.volunteerHoursInfo;
    },
    totalVolunteerHours() {
      return this.$store.getters.totalVolunteerHours;
    },
    totalHealthcareExperienceHours() {
      return this.$store.getters.totalHealthcareExperienceHours;
    },
    userExams() {
      return this.$store.getters.userExams;
    },
    overallCaspaGpa() {
      return this.$store.getters.overallCaspaGpa;
    },
    scienceCaspaGpa() {
      return this.$store.getters.scienceCaspaGpa;
    },
    nonscienceCaspaGpa() {
      return this.$store.getters.nonscienceCaspaGpa;
    },
    userColleges() {
      return this.$store.getters.userColleges;
    }
  }
};
</script>

<style scoped>
#card {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: rgb(224, 224, 224);
}
.caspaCard {
  border-radius: 5px;
}
.menu {
  z-index: 100;
  position: fixed;
  bottom: 0;
}
::-webkit-scrollbar {
  display: none;
}
.tabContent {
  margin-top: 5px;
}

.alert {
  z-index: 3;
}
a {
  text-decoration: none;
}
.schoolName {
  font-size: 20px;
}

.toolbarContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* img {
  width: 70px;
  height: 70px;
} */

.iconRow {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

#tabs {
  top: 150px;
  position: fixed;
}

h2 {
  color: rgb(87, 87, 87);
  margin-left: 10px;
}

.signupOrLoginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size: 20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}

#buttonShadow {
  position: sticky;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.activeLink {
  background-color: #191340;
}

.wrap {
  padding-top: 5vh;
}

@media (min-width: 900px) {
  .wrap {
    margin-top: 5vh !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Summary.vue